import React, { useEffect, useRef, useState } from 'react';
import { Form } from '@unform/web';
import { FiMail, FiUser, FiLock, FiMap } from 'react-icons/fi';
import { Link } from 'react-router-dom';


import { MdError } from 'react-icons/md';

import * as Yup from 'yup';
import ReCAPTCHA from 'react-google-recaptcha';
import { FormHandles } from '@unform/core';
import Input from '../Forms/Input';
import Button from '../Forms/Button';
import Loader from '../Loader';
import MaskedInput from '../Forms/MaskedInput';
import { ResponseMessage } from '../ResponseMessage';
import getValidationErrors from '../../utils/getValidationErrors';
import { Error } from './styles';
import SelectSimple from '../Forms/SelectSimple';
import Whatsapp from '../WhatsAppCompartilhar';

import api from '../../services/api';
import { authTitle, recaptchaKey, urlWebsite } from '../../config';
import getCep from '../../services/cep';
import { FaBuilding, FaGenderless, FaIdBadge, FaPhone } from 'react-icons/fa';
import CheckboxInput from '../Forms/CheckboxInput';
import { useLanguage } from '../../hooks/Language';
import { countries } from './countries';
import { universidades } from './universidades';
import { useAuth } from '../../hooks/Auth';
import { useToast } from '../../hooks/Toast';
import { useConfiguration } from '../../hooks/Configuration';
interface IRecoverFormData {
  name: string;
  email: string;
  password: string;
  phone: string;
  captcha: string;
  birth_date: string;
  document_number: string;
  extra_4: Array<string>,
  extra_5: Array<string>,
  extra_3: Array<string>,
  extra_1: string,
  extra_2?: string,
  country?: string;

}

interface ICaptcha {
  getValue(): string;
}
declare global {
  interface Window {
    grecaptcha: any
  }
}
const FormContainer = ({ context = {} }) => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState<Array<string>>([]);
  const [withPassword, setWithPassword] = useState(true);
  const formRef = useRef<FormHandles>(null);
  const recaptchaRef = useRef(null);
  const { translate } = useLanguage();
  const { configuration } = useConfiguration();
  const getCaptchaValue = (elem: ICaptcha): string => {
    return elem.getValue();
  };

  const { signIn } = useAuth();

  const [deficiencia, setDeficiencia] = useState('Não');
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [category1Options, setCategory1Options] = useState([]);
  const [category, setCategory] = useState('');



  const [extra1, setExtra1] = useState('');
  const [extra2, setExtra2] = useState('');
  const [countryISO, setCountryISO] = useState('BR');

  const [inscricao1, setInscricao1] = useState('');
  const [inscricao2, setInscricao2] = useState('');

  const [company, setCompany] = useState('');


  const [categoryValue, setCategoryValue] = useState('');
  const [categoryValuePos, setCategoryValuePos] = useState('');
  const [category1Value, setCategory1Value] = useState('');


  const options = {


    "pos": [


      { label: 'Biociências', value: 'Biociências' },
      { label: 'Ciências da Nutrição', value: 'Ciências da Nutrição' },
      { label: 'Ciências da Reabilitação', value: 'Ciências da Reabilitação' },
      { label: 'Ciências da Saúde', value: 'Ciências da Saúde' },
      { label: 'Enfermagem', value: 'Enfermagem' },
      { label: 'Ensino na Saúde', value: 'Ensino na Saúde' },
      { label: 'Hepatologia', value: 'Hepatologia' },
      { label: 'Patologia', value: 'Patologia' },
      { label: 'Pediatria', value: 'Pediatria' },
      { label: 'Psicologia e Saúde', value: 'Psicologia e Saúde' },
      { label: 'Saúde da Família', value: 'Saúde da Família' },
      { label: 'Tecnologia em Informação e Gestão em Saúde', value: 'Tecnologia em Informação e Gestão em Saúde' },
      { label: 'Outro', value: 'Outro? Qual?' },
    ],



    'Estudante de graduação': [
      { label: 'Biomedicina - diurno', value: 'Biomedicina - diurno' },
      { label: 'Biomedicina - noturno', value: 'Biomedicina - noturno' },
      { label: 'Biotecnologia', value: 'Biotecnologia' },
      { label: 'Ciências Biológicas/Biologia', value: 'Ciências Biológicas/Biologia' },
      { label: 'Ciências Sociais', value: 'Ciências Sociais' },
      { label: 'Educação Física', value: 'Educação Física' },
      { label: 'Enfermagem', value: 'Enfermagem' },
      { label: 'Engenharia Ambiental', value: 'Engenharia Ambiental' },
      { label: 'Engenharia de Alimentos', value: 'Engenharia de Alimentos' },
      { label: 'Farmácia', value: 'Farmácia' },
      { label: 'Física', value: 'Física' },
      { label: 'Física Médica', value: 'Física Médica' },
      { label: 'Fisioterapia', value: 'Fisioterapia' },
      { label: 'Fonoaudiologia', value: 'Fonoaudiologia' },
      { label: 'Gastronomia', value: 'Gastronomia' },
      { label: 'Gestão em Saúde', value: 'Gestão em Saúde' },
      { label: 'Informática Biomédica', value: 'Informática Biomédica' },
      { label: 'Medicina', value: 'Medicina' },
      { label: 'Nutrição', value: 'Nutrição' },
      { label: 'Odontologia', value: 'Odontologia' },
      { label: 'Pedagogia', value: 'Pedagogia' },
      { label: 'Psicologia', value: 'Psicologia' },
      { label: 'Química', value: 'Química' },
      { label: 'Química Medicinal', value: 'Química Medicinal' },
      { label: 'Saúde Coletiva', value: 'Saúde Coletiva' },
      { label: 'Serviço Social', value: 'Serviço Social' },

      { label: 'Tecnologia em Alimentos', value: 'Tecnologia em Alimentos' },
      { label: 'Toxicologia Analítica', value: ' Toxicologia Analítica' },
      { label: 'Outro', value: 'Outro? Qual?' },
    ],
    'Estudante de pós-graduação': [
      { label: ' Especialização', value: ' Especialização' },
      { label: ' Residência médica', value: ' Residência médica' },
      { label: ' Residência multiprofissional', value: ' Residência multiprofissional' },
      { label: ' Mestrado', value: ' Mestrado' },
      { label: ' Doutorado', value: ' Doutorado' },
      { label: 'Outro', value: 'Outro? Qual?' },
    ],

  }



  useEffect(() => {



    setCategoryOptions(options[category] ? options[category] : []);


  }, [category])

  useEffect(() => {



    setCategory1Options(options[extra1] ? options[extra1] : []);


  }, [extra1])

  const states = [
    { uf: 'AC', label: 'Acre (AC)', value: 1 },
    { uf: 'AL', label: 'Alagoas (AL)', value: 2 },
    { uf: 'AP', label: 'Amapá (AP)', value: 3 },
    { uf: 'AM', label: 'Amazonas (AM)', value: 4 },
    { uf: 'BA', label: 'Bahia (BA)', value: 5 },
    { uf: 'CE', label: 'Ceará (CE)', value: 6 },
    { uf: 'DF', label: 'Distrito Federal (DF)', value: 7 },
    { uf: 'ES', label: 'Espírito Santo (ES)', value: 8 },
    { uf: 'GO', label: 'Goiás (GO)', value: 9 },
    { uf: 'MA', label: 'Maranhão (MA)', value: 10 },
    { uf: 'MT', label: 'Mato Grosso (MT)', value: 11 },
    { uf: 'MS', label: 'Mato Grosso do Sul (MS)', value: 12 },
    { uf: 'MG', label: 'Minas Gerais (MG)', value: 13 },
    { uf: 'PA', label: 'Pará (PA)', value: 14 },
    { uf: 'PB', label: 'Paraíba (PB)', value: 15 },
    { uf: 'PR', label: 'Paraná (PR)', value: 16 },
    { uf: 'PE', label: 'Pernambuco (PE)', value: 17 },
    { uf: 'PI', label: 'Piauí (PI)', value: 18 },
    { uf: 'RJ', label: 'Rio de Janeiro (RJ)', value: 19 },
    { uf: 'RN', label: 'Rio Grande do Norte (RN)', value: 20 },
    { uf: 'RS', label: 'Rio Grande do Sul (RS)', value: 21 },
    { uf: 'RO', label: 'Rondônia (RO)', value: 22 },
    { uf: 'RR', label: 'Roraima (RR)', value: 23 },
    { uf: 'SC', label: 'Santa Catarina (SC)', value: 24 },
    { uf: 'SP', label: 'São Paulo (SP)', value: 25 },
    { uf: 'SE', label: 'Sergipe (SE)', value: 26 },
    { uf: 'TO', label: 'Tocantins (TO)', value: 27 },
    { uf: '', label: 'Não sou Brasileiro', value: 28 },
  ];

  const { addToast } = useToast();

  const handleNewLogin = async (data: IRecoverFormData) => {
    setLoading(true);

    data.birth_date = data.birth_date
      ? data.birth_date.toString().replace(/[^0-9/]/g, '')
      : '';

    try {
      formRef.current?.setErrors({});

      let shape: Record<string, any> = {
        name: Yup.string().required('O campo Nome é obrigatório'),

        email: Yup.string()
          .email('Preencha um email válido')
          .required('O campo Email é obrigatório'),
        phone: Yup.string().required('o campo Celular é obrigatório'),
        term: Yup.string().required('O campo Termo é obrigatório'),
        company: Yup.string().required('O campo Instituição é obrigatório'),


        gender_id: Yup.string().required('O campo Gênero é obrigatório'),
        address: Yup.string().required('O campo Endereço é obrigatório'),

        neighborhood: Yup.string().required('O campo bairro é obrigatório'),

        city: Yup.string().required('O campo Cidade é obrigatório'),
        state: Yup.string().required('O campo Estado é obrigatório'),
        country: Yup.string().required('O campo País é obrigatório'),
        password: Yup.string().required('O campo Senha é obrigatório'),
      };



      if (data?.country === 'BR') {
        shape.zipcode = Yup.string().required(`O campo CEP é obrigatório`);
        shape.document_number = Yup.string().required(`O campo CPF é obrigatório`);

      };



      shape.category_id = Yup.string().required('O campo Categoria é obrigatório');





      if (categoryOptions?.length > 0) {
        shape.facebook = Yup.string().required(`O campo ${category === 'Estudante de graduação' ? 'curso' : 'subcategoria'} obrigatório`);

      };

      if (category === 'Estudante de pós-graduação') {
        shape.extra_1 = Yup.string().required(`O campo curso é obrigatório`);

      }

      if (data?.extra_1 === 'Outro? Qual?') {
        shape.extra_2 = Yup.string().required(`Informe o seu curso`);

      }


      const schema = Yup.object().shape(shape);

      await schema.validate(data, { abortEarly: false });

      const captchaValue =
        getCaptchaValue(recaptchaRef?.current || { getValue: () => '' }) ||
        false;




      const response = await api.post(`/signup`, {
        ...data,
        document_number: data?.document_number.toString().replace(/[^0-9]/g, '') || '',
        extra_4: data?.extra_4 && data?.extra_4?.[0] ? data?.extra_4?.[0] : '',
        extra_5: data?.extra_5 && data?.extra_5?.[0] ? data?.extra_5?.[0] : '',
        event_id: configuration?.current_event_id_response?.url,
        project_id: configuration?.url,

        captcha: captchaValue,
        product: configuration?.current_event_id_response?.product_id
      });


      await signIn({ email: data.email, password: data.password });
      setSuccess(true);

      setLoading(false);
    } catch (err) {
      window?.grecaptcha?.reset();
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);
        if (formRef && formRef.current && formRef.current.setErrors) {
          formRef.current.setErrors(errors);
        }
        setLoading(false);

        const errorsString = Object.keys(errors).reduce(
          (prev: Array<string>, key: string): Array<string> => {
            prev = [...prev, errors[key]];
            return prev;
          },
          [],
        );

        setErrorMessage(errorsString);

        return;
      }

      setErrorMessage([
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        'Erro ao gerar seu cadastro',
      ]);
    }
    setLoading(false);
  };

  const getCepFromApi = async (value: string): Promise<void> => {
    const cepResponse = await getCep(value);


    const state = cepResponse.uf
      ? states.find(st => {
        return st.uf === cepResponse.uf;
      })
      : false;

    if (!cepResponse.error) {
      formRef?.current?.setFieldValue('address', cepResponse.logradouro);
      formRef?.current?.setFieldValue('neighborhood', cepResponse.bairro);
      formRef?.current?.setFieldValue('city', cepResponse.localidade);
      if (state) {

        formRef?.current?.setFieldValue('state', state.uf);
      }
    }
  };

  return (
    <>
      {loading === true && (
        <Loader message="Preparando seu cadastro..." position="fixed" />
      )}

      <aside>
        {success ? (
          <ResponseMessage
            active
            type="success"
            title="Sucesso"
            description={
              <p style={{ color: '#333' }}>
                Cadastro realizado com sucesso!
                <br />
                A submissão de trabalhos inicia no dia 10/08
                <br />
                <Link to="/app/simposio/login">
                  <Button style={{ width: '100%' }} type="button">
                    Acessar
                  </Button>
                </Link>
                {/* <br />
                <br />
                <Link to="/trabalhos">
                  <Button style={{ width: '100%' }} type="button">
                    Submeter Trabalhos
                  </Button>
            </Link>*/}
                Aproveite e indique para seus amigos!
                <Whatsapp
                  text={`Olá! Acabei de me inscrever no evento ${authTitle}. Inscreva-se também!. ${urlWebsite}`}
                  number=""
                  message="Compartilhe!"
                />
              </p>
            }
          />
        ) : (
          <>
            {/* <Link to='/app/mostra-ufcspa/login'><button className="defaultButton" style={{ width: '100%', maxWidth: '400px', margin: '15px auto' }}>Já tenho cadastro / Complementar inscrição</button></Link> */}
            <div className='separatorDiv' />
            <Form style={{ background: '#fff', padding: '15px', borderRadius: '15px' }} ref={formRef} onSubmit={handleNewLogin} initialData={{ country: 'BR' }}>
              <h1 style={{ color: '#333', marginTop: '25px' }}>Nova inscrição</h1>
              <h3 style={{ margin: '10px 0px', marginTop: '25px', color: '#333' }}> Todos os campos são de preenchimento obrigatório</h3>



              <Input name="name" placeholder="Nome Completo" />
              <MaskedInput mask='999.999.999-99' name="document_number" placeholder="CPF - Somente Brasileiros" />
              <Input type="email" name="email" placeholder="E-mail" />

              <SelectSimple label="Gênero" name="gender_id" options={[
                { value: 'Masculino', label: 'Masculino' },
                { value: 'Feminino', label: 'Feminino' },
                { value: 'Não binário', label: 'Não binário' },
                { value: 'Prefiro não declarar', label: 'Prefiro não declarar' }

              ]} />

              <SelectSimple name="disability_id" setCallback={(value) => { setDeficiencia(value || 'Não') }} label="Você têm alguma deficiência?" options={[
                { value: 'Sim', label: 'Sim' },
                { value: 'Não', label: 'Não' },

              ]} />
              {deficiencia === 'Sim' && <Input name="disability_type" placeholder="Qual? Cite o tipo de auxílio necessário." />}
              <MaskedInput mask='(99) 99999-9999' icon={FaPhone} name="phone" placeholder="Telefone Celular" />












              <h3 style={{ margin: '10px 0px', marginTop: '25px', color: '#333' }}>Categoria</h3>
              <SelectSimple name="category_id" setCallback={(value) => { setCategory(value || '') }} label="Categoria" options={[
                { value: 'Estudante de graduação', label: 'Estudante de graduação' },
                { value: 'Estudante de pós-graduação', label: 'Estudante de pós-graduação' },
                { value: 'Professor/pesquisador', label: 'Professor/pesquisador' },
                { value: 'Técnico-administrativo', label: 'Técnico-administrativo' },
                { value: 'Profissional', label: 'Profissional' },

              ]} />



              {categoryOptions && categoryOptions?.length > 0 && <SelectSimple setCallback={(value) => setCategoryValue(value)} name="facebook" options={categoryOptions} label={category === 'Estudante de graduação' ? "Cursos" : 'Subcategoria'} />}
              {categoryValue === 'Outro? Qual?' && <Input name="facebook" placeholder="Qual?" />}



              {category === 'Estudante de pós-graduação' ? <SelectSimple setCallback={(value) => setCategoryValuePos(value)} name="extra_1" options={options?.['pos']} label="Cursos" /> : <></>}
              {categoryValuePos === 'Outro? Qual?' && <Input name="extra_2" placeholder="Qual?" />}





              <SelectSimple name="company" setCallback={(value) => setCompany(value)} options={category === 'Profissional' ? [{ label: 'Autônomo', value: 'Autônomo' }, ...universidades] : universidades} label="Instituição" />
              {company === 'Outro? Qual?' && <Input name="company" placeholder="Qual?" />}
              <p style={{ fontSize: '12px', marginBottom: '20px', marginTop: '10px', color: '#333' }}>*Profissional sem vínculo universitário favor colocar "Autônomo" na opção "Instituição".</p>


              <p style={{ margin: '10px 0px', color: '#333' }}>Endereço completo</p>
              <SelectSimple setCallback={(value) => setCountryISO(value)} options={countries} name="country" label={translate('Pais')} />
              {countryISO === 'BR' ?
                <MaskedInput

                  setCallback={getCepFromApi}
                  mask="99999999"
                  name="zipcode"
                  placeholder={translate('CEP')}
                /> : <Input name="zipcode" placeholder={translate('ZIP Code')} />}
              <Input name="address" placeholder={translate('Endereço')} />
              <Input name="address_number" placeholder={translate('Número / Apartamento')} />
              <Input name="neighborhood" placeholder={translate('Bairro')} />
              <Input name="city" placeholder={translate('Cidade')} />
              {countryISO === 'BR' ? <MaskedInput mask="aa" name="state" placeholder={translate('Estado')} /> :

                <Input name="state" placeholder={translate('Província / Região')} />}

              {withPassword && (
                <Input
                  icon={FiLock}
                  name="password"
                  type="password"
                  placeholder="senha"
                />
              )}

              <CheckboxInput name="term" options={[{ value: 'Li e aceito a política de privacidade do evento III 36º Simpósio de Oftalmologia do HCPA', label: 'Li e aceito a política de privacidade do evento III 36º Simpósio de Oftalmologia do HCPA', id: 'Li e aceito a política de privacidade do evento III 36º Simpósio de Oftalmologia do HCPA' }]} />
              <CheckboxInput name="extra_4" options={[{ value: 'Aceito receber as comunicações da FUNDMED', id: 'Aceito receber as comunicações da FUNDMED', label: 'Aceito receber as comunicações da FUNDMED' }]} />
              <CheckboxInput name="extra_5" options={[{ value: 'Aceito receber as comunicações da UFCSPA', id: 'Aceito receber as comunicações da UFCSPA', label: 'Aceito receber as comunicações da UFCSPA' }]} />
              <p
                style={{
                  padding: '10px',
                  background: 'none',
                  margin: '5px auto',
                  color: '#333',
                  fontSize: '14px',
                  textAlign: 'center',
                }}
              >
                {translate('Ao me cadastrar, afirmo que li e aceito a')}
                {' '}
                <strong>
                  <Link
                    style={{ display: 'inline', color: '#333' }}
                    to="/termos"
                    target="_BLANK"
                  >
                    {translate('POLÍTICA DE PRIVACIDADE')}
                    {' '}
                  </Link>
                  {' '}
                </strong>
                {translate('do evento.')}
              </p>
              <aside style={{ display: 'flex', justifyContent: 'center' }}>
                <ReCAPTCHA ref={recaptchaRef} sitekey={recaptchaKey} /></aside>
              {errorMessage && (
                <Error>
                  {errorMessage.map((item, index) => (
                    <div key={`error${index}`}>
                      <MdError />
                      {item}
                    </div>
                  ))}
                </Error>
              )}

              <aside style={{ display: 'flex', justifyContent: 'center' }}>
                <Button style={{ width: '100%' }} type="submit">
                  Cadastrar
                </Button>
              </aside>
            </Form></>
        )}
      </aside>
    </>
  );
};

export default FormContainer;
